import Main from './Main.vue'

export default [{
  path: 'pregao-lance/:id',
  name: 'pregaolance',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-lance/routes.js